
import moment from 'moment/moment';
import { ODIcon } from "../ODIcon";

export const LastModfiedCell = ({ doctorModifiedOn, doctorModifiedBy }) => {
    return (
        <div className="flex gap-2  items-center w-full">
            <button className="border border-[ #70829B] flex items-center justify-center h-10 w-10 rounded-full">
                <ODIcon src={"/assets/ProfilePlaceholder.svg"} width={50} height={50} className={'flex items-center justify-center'} alt="Placeholder" />
            </button>
            <div className="flex flex-col flex-1">
                <p className=' text-sm font-medium  '>
                   {doctorModifiedBy}
                </p>
                <p className="text-s text-gray-500 ">
                    {moment(doctorModifiedOn).format('DD-MMM-YYYY, h:mm a')}
                </p>
            </div>
        </div>
    )
}
